export default "__VITE_ASSET__52c9804c__"